import {ApiRegistryRepository} from 'vue3-starter/src/typescript/api-registry/ApiRegistryRepository';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {config} from '@/profile-creation-wizard/config/applicationConfig';

export async function setupContext(): Promise<void> {
    context.registryApi = config.apiRegistryUrl;

    const apiRegistryRepository = new ApiRegistryRepository();
    const [registry, err] = await apiRegistryRepository.get();

    if (err || !registry) {
        throw new Error('Unable to get/set application api registry');
    }
    context.registry = registry;
}
